import React from "react";
import { toElementProps } from "../../Element";
import ProductTypeImage, { ProductTypeImageStyles } from "./ProductTypeImage.jsx";

export function BlockHeaderImageHorizontalStyles(params = {}) {
    const { MobileBreakpoint } = params;

    return {
        "& .block-header-image-horizontal": {
            maxHeight: "70vh",

            "&.mobile-app": {
                "& img, svg": {
                    maxHeight: "70vh",
                },
            },

            [MobileBreakpoint]: {
                marginTop: "0 !important",
                height: "auto",
            },
        },

        ...ProductTypeImageStyles(params),
    };
}

export default function BlockHeaderImageHorizontal(props) {
    const { ProductType } = props.variables;

    let CNImageHorizontal = ["block-header-image-horizontal", ProductType];
    props.position !== "left" && CNImageHorizontal.push("left-position-height");

    const elProps = toElementProps(props, { className: CNImageHorizontal });
    return (
        <div {...elProps}>
            <ProductTypeImage variables={props.variables} />
        </div>
    );
}
